import { EventDispatcher } from '../events/EventDispatcher';

export class Lock {
  private locked = false;
  private readonly onRelease = new EventDispatcher<void>();

  public async acquire(): Promise<void> {
    return new Promise(resolve => {
      if (!this.locked) {
        this.locked = true;
        resolve();
        return;
      }

      const tryAcquire = (): void => {
        if (!this.locked) {
          this.locked = true;
          this.onRelease.removeListener(tryAcquire);
          resolve();
        }
      };

      this.onRelease.addListener(tryAcquire);
    });
  }

  public release(): void {
    this.locked = false;
    queueMicrotask(() => this.onRelease.dispatch());
  }
}
